import { applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import loggerMiddleware from 'common/modules/middleware/loggerMiddleware'

import logger from 'common/logger'
import { sagaMiddleware } from './sagas'

const bindMiddleware = (middleware) => composeWithDevTools(applyMiddleware(...middleware))

const composeMiddleware = ({
    middleware = [],
}) => bindMiddleware([
    sagaMiddleware,
    loggerMiddleware([
        {
            actionTypeMatch: (actionType) => (
                actionType?.includes('ERROR')
            ),
            loggerFunction: ({
                storeAPI,
                action,
            }) => {
                const state = storeAPI?.getState()
                const errorText = action?.error || action?.payload?.error?.message || action.type
                const loader = state?.loader?.user || state?.loader?.guest

                logger.error(errorText, {
                    action,
                    loader,
                })
            },
        },
    ]),
    ...middleware,
])

export default composeMiddleware
